<template>
  <div>
    <app-header
      @cancel-transaction="callCancelTransaction"
      :is-cancelling="isCancelling"
      :is-show-retry="false"
      :close-cancel-transaction-modal="closeCancelTransactionModal"
    ></app-header>
    <banner />
    <loading v-if="isLoading" />
    <div class="banks-section-wrapper content-wrapper" v-else>
      <progress-bar :currentStep="1"></progress-bar>
      <div class="header-request">
        <h3>Please select your bank</h3>
        <p>None of your bank credentials will be stored or saved.</p>
      </div>
      <bank-list :list="banksList" @select-bank="selectBank"></bank-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import BankList from '@/components/BankList.vue'
import ProgressBar from '@/components/ProgressBar'
import Header from '@/components/Header'
import Loading from '@/components/Loading'
import Banner from '@/components/Banner'
import { isOpenBankingAcquirer } from '@/utils'
import Constants from '@/constants'
import BannerEvent from '@/events/bannerEvents'
import { cancelTransaction } from '@/services/transactionService'

export default {
  name: 'Banks',
  components: {
    'app-header': Header,
    BankList,
    ProgressBar,
    Banner,
    Loading,
  },

  data() {
    return {
      closeCancelTransactionModal: +new Date(),
      isLoading: false,
      isCancelling: false,
      showWarning: false,
    }
  },

  computed: {
    ...mapGetters('merchantSettings', ['banksList']),
    ...mapState('merchantSettings', ['paymentMessage', 'paymentShowMessage']),

    transactionId() {
      return this.$route.query.transactionId
    },
  },
  methods: {
    ...mapActions('transaction', ['getTransaction', 'updateTransaction']),

    async callCancelTransaction() {
      const transactionId = this.transactionId
      try {
        this.isCancelling = true
        this.$logInfo({
          transactionId,
          message: Constants.logMessages.cancelOnBankSelect,
        })
        await cancelTransaction({
          transactionId,
        })
        this.closeCancelTransactionModal = +new Date()
        await this.$router
          .push({ name: 'cancelled', query: { transactionId } })
          .catch((e) => {
            console.info(e)
          })
        this.isCancelling = false
      } catch (e) {
        this.isCancelling = false
      }
    },

    async selectBank(acquirerCode) {
      const transactionId = this.transactionId
      const routeName = isOpenBankingAcquirer(acquirerCode)
        ? 'login'
        : 'progress'

      try {
        this.isLoading = true
        await this.updateTransaction({
          transactionId,
          data: {
            AcquirerCode: acquirerCode,
          },
        })

        await this.$router.push({
          name: routeName,
          query: { transactionId },
        })
        this.isLoading = false
      } catch (err) {
        console.error('error', err)
        this.isLoading = false
      }
    },
  },
  async created() {
    this.isLoading = true

    const queryParams = this.$route.query
    const queryParamsUpper = {}
    Object.keys(queryParams).forEach((queryKey) => {
      queryParamsUpper[queryKey.toUpperCase()] = queryParams[queryKey]
    })

    if (queryParamsUpper.SID_MERCHANT !== undefined) {
      // Here we know the user has used back to go back to the bank page
      // DEV: Struggled to figure out how to call Main.setUpFromMerchant() from here and get the response,
      //  from the API call,  just no response
      //  so that I can change the url, including the newly created transactionID
      const error = new Error(`User navigated back to bank select page`)
      this.$handleException({ error })
    }

    // Check if the transaction does not have an acquirer set
    if (this.transactionId) {
      const transactionCheck = await this.getTransaction({
        transactionId: this.transactionId,
      })

      // if AcquirerCode is set, push user to progress
      if (transactionCheck.acquirerCode) {
        // Have to assign to variable, in order to use below when calling this.$router.push
        const transactionId = this.transactionId
        let params = this.$route.query
        //if (!isNotUndefinedOrNull(params.code)) params = {}
        await this.$router.push({
          name: 'progress',
          query: { ...params, transactionId },
        })
      }
    }

    this.isLoading = false
    const bannerMessage = this.paymentShowMessage ? this.paymentMessage : ''
    BannerEvent.setBanner(bannerMessage)
  },
}
</script>

<style lang="scss" scoped>
.banks-section-wrapper {
  display: grid;
  place-items: center;
  height: 80%;
  padding: 0 20px 20px 20px;

  @media screen and (max-width: $mobile-resolution) {
    padding: 0;
  }
}
</style>
